module.exports = __webpack_public_path__ + "static/media/icon-check.55fbb7da.svg";